import styled, { css } from 'styled-components';

import { colors, radius } from '../../styles/tokens';

interface ContainerInputProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const Container = styled.div`
  width: 100%;
`;

export const ContainerInput = styled.div<ContainerInputProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  transition: border-color 0.2s;

  width: 100%;
  height: 64px;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};

  background-color: ${colors.surfaceContainerHigh};

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.primary};
    `}
`;

export const Input = styled.input`
  flex: 1;
  padding: 0;
  border: none;
  background-color: transparent;

  color: ${colors.onSurface};

  font-size: 24px;
  font-weight: 600;
  text-align: center;

  overflow: hidden;

  text-transform: uppercase;
`;

export const ContainerError = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  span {
    color: ${colors.error};
  }
`;
